import React from 'react'

// components
import CartProduct from './CartProduct'

// helpers
import { cartCoppaProduct } from 'lib/cart/decorators/cartForm'
import { centsToDollars } from 'lib/helpers/money'

const CoppaFee = ({ account, campers, cartForm, sessions }) => {
  const coppaProduct = cartCoppaProduct({
    account,
    campers,
    cartForm,
    sessions
  })

  if (!coppaProduct) {
    return null
  }

  return (
    <CartProduct
      description={coppaProduct.description}
      total={centsToDollars(coppaProduct.priceCents)}
    />
  )
}

export default CoppaFee
